module.exports = __webpack_public_path__ + "img/bg_login.874d830f.png";